import { render } from "./TraceBack.vue?vue&type=template&id=84165efa&scoped=true&lang=pug"
import script from "./TraceBack.vue?vue&type=script&lang=js"
export * from "./TraceBack.vue?vue&type=script&lang=js"

import "./TraceBack.vue?vue&type=style&index=0&id=84165efa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\freemath\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84165efa"]])

export default __exports__